/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type MenuCollectionsQueryVariables = Types.Exact<{
  menuId: Types.Scalars['ID']['input'];
}>;

export type MenuCollectionsQuery = {
  readonly __typename?: 'Query';
  readonly menuCollections: ReadonlyArray<{
    readonly __typename?: 'MenuCollection';
    readonly id: string;
    readonly color: string;
    readonly primaryImageUrl: string;
    readonly primaryTitle: string;
    readonly primaryDescription: string;
  }>;
};

export const menuCollectionsQueryMock: ExecutionResult<MenuCollectionsQuery> = {
  data: {
    menuCollections: [
      {
        id: '509e6ea9-fee4-42a9-9625-87ce71904308',
        color: 'Hello World',
        primaryImageUrl: 'Hello World',
        primaryTitle: 'Hello World',
        primaryDescription: 'Hello World',
      },
      {
        id: 'da7a7163-ba7e-4da9-ae8a-185e3da00a9a',
        color: 'Hello World',
        primaryImageUrl: 'Hello World',
        primaryTitle: 'Hello World',
        primaryDescription: 'Hello World',
      },
      {
        id: '47534319-d080-460b-99aa-250f9c4016b1',
        color: 'Hello World',
        primaryImageUrl: 'Hello World',
        primaryTitle: 'Hello World',
        primaryDescription: 'Hello World',
      },
    ],
  },
};

export const MenuCollectionsDocument = gql`
  query MenuCollections($menuId: ID!) {
    menuCollections(menuId: $menuId) {
      id
      color
      primaryImageUrl
      primaryTitle
      primaryDescription
    }
  }
`;

export function useMenuCollectionsQuery(
  options: Omit<Urql.UseQueryArgs<MenuCollectionsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<MenuCollectionsQuery, MenuCollectionsQueryVariables>({
    query: MenuCollectionsDocument,
    ...options,
  });
}
